import(/* webpackMode: "eager", webpackExports: ["ProductFinder"] */ "/app/src/components/products/ProductFinder.tsx");
